import React, { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import Button from "../components/Button";
import { FieldGroup, InputGroup } from "../components/Input";
import { validateEmail } from "../utils.js";
import { API_ENDPOINTS } from "../config/api";
import useTranslation from "../hooks/useTranslation";

// Import Icons
import { ReactComponent as UserIcon } from "../img/icons/single-user.svg";
import axios from "axios";

const ResetPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateEmail(email).length !== 0) {
      setError(validateEmail(email));
      return;
    }
    axios
      .post(
        API_ENDPOINTS.RESET_PASSWORD,
        { email },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        toast.info(res.data.message);
      })
      .catch((err) => {
        setError(err.response?.data?.message);
      });
  };
  return (
    <ResetPasswordStyle>
      <button className="close-btn" onClick={() => { window.location.href = "/"; }} aria-label="Close">×</button>
      <header>
        <h2>{t('resetpassword.forgot_password')}</h2>
        <p>{t('resetpassword.use_email_message')}</p>
      </header>
      <form autocomplete="off" onSubmit={handleSubmit} noValidate>
        <FieldGroup label={t('resetpassword.email_address')}>
          <InputGroup
            name="email"
            placeholder="example@gmail.com"
            type="email"
            iconLeft={UserIcon}
            alert={error}
            onChange={handleChange}
            autoFocus
          />
        </FieldGroup>
        <Button type="submit" variant="primary">
          {t('resetpassword.reset_password')}
        </Button>
      </form>
    </ResetPasswordStyle>
  );
};
export default ResetPassword;

const ResetPasswordStyle = styled.div`
  max-width: 400px;
  margin: 10vw auto 0;
  position: relative;
  .close-btn {
    position: absolute;
    top: -24px;
    right: -24px;
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.color.primaryText};
    font-size: 28px;
    cursor: pointer;
  }
  header {
    margin-bottom: 3rem;
    h2 {
      margin-bottom: 10px;
    }
    p {
      color: ${({ theme }) => theme.color.lighterText};
    }
  }
  form {
    button {
      width: 100%;
      margin-top: 20px;
    }
  }
`;
